import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

const buttonStyles = {
  border: 'solid 0.1rem rgba(15,23,42,0.25)',
  borderRadius: '0.35rem',
  '&:not(:last-child)': {
    marginBottom: '0.75rem',
  },
  '&:hover, &:focus': {
    borderColor: '#0D9488',
  },
};

export const MemberDialogAction = ({
  onSelectAction,
  actionLabel,
  actionIcon: ActionIcon,
  ...props
}) => {
  return (
    <ListItemButton onClick={onSelectAction} sx={buttonStyles} {...props}>
      <ListItemIcon>
        <ActionIcon alt="" />
      </ListItemIcon>
      <ListItemText>{actionLabel}</ListItemText>
    </ListItemButton>
  );
};
